<template>
    <div>
        <Header> </Header>
        <Row className="pos1">
            <img src="@/assets/mobile/service/pos1-bg.jpg" />
            <h4>突破营销技术边界 构建全链路营销服务矩阵</h4>
            <p>
                通过互联网、数字传播技术和数字交互式媒体来实现营销目标，提供智能营销、数字广告<br />
                社群营销、电商运营等服务，致力于为客户量身定制跨平台、 多场景的整合数字营销解决方案。
            </p>
        </Row>
        <Row className="pos2" bg="assets/mobile/service/pos2-bg.jpg">
            <h4>全方位构建品牌传播体系 提升品牌商业价值</h4>
            <p>
                致力于构建全方位的品牌体系，通过品牌管理与咨询、<br />
                公关传播、社会化媒体传播、事件营销等，<br />
                助力客户管理品牌战略定位与品牌价值，<br />
                打造全内容传播解决方案。
            </p>
        </Row>
        <Row className="pos3" bg="assets/mobile/service/pos3-bg.jpg">
            <h4>聚焦内容 全渠道内容生态助力营销</h4>
            <p>
                构建“全链路”、“跨渠道”、“多场景”、“数据化”<br />
                一体的智慧内容营销生态平台，拥有自有媒体、短视频及<br />
                直播内容生产与制作、流量运营、汽车直播运营、<br />
                红人主播培养能力以及丰富KOL资源，赋能客户内容营销生态。
            </p>
        </Row>
        <Row className="pos4" bg="assets/mobile/service/pos4-bg.jpg">
            <h4>数字营销与文化产业融合共促 创新引领行业发展</h4>
            <p>
                延伸布局元宇宙虚拟资产、影视IP运营、电竞娱乐等领域，<br />
                打破营销次元，推进数字化赋能文创业态发展，构建数字资产实<br />现由实体到虚拟的价值与新营销生态体系。
            </p>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Header from "../../components/mobile/header.vue";
import Footer from "../../components/mobile/footer.vue";
import Row from "../../components/mobile/Row.vue";
export default {
    name: "mobile-service",
    components: { Header, Footer, Row },
    data() {
        return {};
    },
    mounted() {
        var pos = this.$route.query.p;
        if (!pos) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            return;
        } else {
            this.$nextTick(() => {
                document.querySelector("." + this.$route.query.p).scrollIntoView();
            });
        }
    },
};
</script>
<style scoped>
.pos4 h4 {
    font-size: 1.6rem;
    margin: 125% 15px 30px 15px;
    font-weight: normal;
}
.pos4 p {
    color: #666666;
    font-size: 1.2rem;
    line-height: 2.5rem;
    margin: 0 15px 40px 15px;
}
.pos3 h4 {
    font-size: 1.6rem;
    margin: 125% 15px 30px 15px;
    font-weight: normal;
}
.pos3 p {
    color: #666666;
    font-size: 1.2rem;
    line-height: 2.5rem;
    margin: 0 15px 40px 15px;
}
.pos2 h4 {
    font-size: 1.6rem;
    margin: 125% 15px 30px 15px;
    font-weight: normal;
}
.pos2 p {
    color: #666666;
    font-size: 1.2rem;
    line-height: 2.5rem;
    margin: 0 15px 40px 15px;
}
.pos1 h4 {
    font-size: 1.6rem;
    margin: 30px 0;
    font-weight: normal;
}
.pos1 p {
    color: #666666;
    font-size: 1.2rem;
    line-height: 2.5rem;
    margin: 0 15px 40px 15px;
}
</style>
